export const VUEX_NAVIGATION_DIALOG_SHOW = 'VUEX_NAVIGATION_DIALOG_SHOW'
export const VUEX_NAVIGATION_DIALOG_HIDE = 'VUEX_NAVIGATION_DIALOG_HIDE'
export const VUEX_NAVIGATION_DIALOG_SET_PROPS = 'VUEX_NAVIGATION_DIALOG_SET_PROPS'
